import React from "react";
const d3 = require("d3");

let timer = null;

const gradients = {
  gpos25: { 3: "#C8C8C8", 15: "#e6e6e6", 60: "#ccc" },
  gpos50: { 3: "#AAA", 15: "#BBB", 66: "#999" },
  gpos75: { 3: "#999", 15: "#999", 66: "#777" },
  gpos100: { 3: "#777", 15: "#999", 66: "#444" },
  acen: { 3: "#FEE", 15: "#FEE", 66: "#FDD" },
  gneg: { 70: "#FFF", 95: "#e6e6e6", 100: "#FFF" },
};

//const impacts = ["low", "moderate", "high", "modifier"];
const impacts = ["moderate"];

function KaryotypeBar(svg, state, xChr) {
  state.karyotype = state.karyotype || [];
  let centre = (state.karyotype || []).filter((box) => box[3] === "acen");
  if (centre.length === 0) {
    centre = [[0, state.chrSize]];
  }

  const kt = svg.append("g").attr("class", "karyotype");

  const bands = kt
    .append("g")
    .attr("clip-path", "url(#chromosome-cp)")
    .attr("class", "bands");

  const cen = xChr(centre[0][1]);
  const end = xChr(state.chrSize);
  const left = `M4,3 L${cen - 4 - 1},3 Q${cen + 4 - 1},15,${
    cen - 4 - 1
  },27 L4,27 Q-4,17,4,3`;
  const right = `M${cen + 4},3 L${end - 4 + 1},3 Q${end + 4 + 1},15,${
    end - 4 + 1
  },27 L${cen + 4},27 Q${cen - 4},15,${cen + 4},3`;

  kt.append("path").attr("class", "chr-border").attr("d", left);
  if (end != cen) {
    kt.append("path").attr("class", "chr-border").attr("d", right);
  }

  const defs = svg.select("defs");
  const cp = defs.append("svg:clipPath").attr("id", "chromosome-cp");
  cp.append("path").attr("d", left);
  cp.append("path").attr("d", right);

  for (let k in gradients) {
    const gradient = defs
      .append("linearGradient")
      .attr("id", k)
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", 0)
      .attr("y2", "100%");
    for (let offset in gradients[k]) {
      gradient
        .append("stop")
        .attr("offset", `${offset}%`)
        .attr("stop-color", gradients[k][offset]);
    }
  }
  const pattern = defs
    .append("pattern")
    .attr("width", "2")
    .attr("height", "1")
    .attr("patternUnits", "userSpaceOnUse")
    .attr("patternTransform", "rotate(-30 0 0)")
    .attr("id", "gvar");
  pattern.append("rect").attr("x", 0).attr("y", 0);
  pattern
    .append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", "100%");

  let last_hint = -30;
  state.karyotype.map((box) => {
    const dx = parseFloat(xChr(box[0]));
    const width = xChr(box[1] - box[0]);
    const mean = parseFloat(xChr(box[1] / 2 + box[0] / 2));

    bands
      .append("rect")
      .attr("transform", `translate(${dx}, 3)`)
      .attr("width", width)
      .attr("height", 24)
      .attr("fill", `url(#${box[3]})`)
      .attr("class", box[3]);

    if (width > 38 || mean - 38 > last_hint) {
      last_hint = mean;

      kt.append("line")
        .attr("class", "karyo-hints")
        .attr("x1", mean)
        .attr("y1", -4)
        .attr("x2", mean)
        .attr("y2", 8);

      kt.append("text")
        .attr("class", "karyo-hints")
        .attr("x", mean - (box[2].length * 5.1) / 2)
        .attr("y", -8)
        .text(box[2]);
    }
  });
}

/**
 * @return {number}
 */
function WordLength(text) {
  return text.length * 7.115;
}

/**
 * @return {boolean}
 */
function Intersect(e, ranges) {
  for (let r in ranges) {
    if (e.p2 >= ranges[r].p1 && ranges[r].p2 >= e.p1) return true;
  }
  return false;
}

function Levels(features, x) {
  let lines = [[], []];

  features = features
    .map((f) => {
      f.width = x(f.end) - Math.max(0, x(f.start));
      f.short = f.gene_name || f.name || f.ensembl_id;
      f.desc = f.description ? f.description : f.SO_biotype.replace(/_/g, " ");
      f.long = `${f.short}, ${f.desc}`;
      f.p1 = x(f.start);
      f.p2 = x(f.end) + 3;
      return f;
    })
    .filter((f) => f.width > 1.5)
    .sort((a, b) => b.width - a.width)
    .map((f) => {
      for (let level in lines) {
        if (Intersect(f, lines[level])) continue;
        lines[level].push({ p1: f.p1, p2: f.p2 });
        f.level = parseInt(level);
        return f;
      }

      f.level = lines.length;
      return f;
    });

  return features;
}

function GenomeBrowser(el, parent) {
  const node = d3.select(el).node();
  if (!node) return;

  console.log("GenomeBrowser [+]");
  let state = parent.state;

  const densityHeight = 36;
  const variantHeight = 16;
  const geneHeight = 34;

  const width = node.getBoundingClientRect().width;
  const offset = 0;

  d3.select(el).html("");

  const svgHeight = 138;

  const svg = d3
    .select(el)
    .append("svg")
    .attr("overflow", "visible")
    .attr("class", "region-plot")
    .attr("viewBox", [0, 0, width, svgHeight]);

  svg
    .append("defs")
    .append("svg:clipPath")
    .attr("id", `clipPath`)
    .append("svg:rect")
    .attr("width", width)
    .attr("height", svgHeight)
    .attr("x", 0)
    .attr("y", 0);

  // Ranges
  let xChr = d3.scaleLinear().range([0, width]).domain([0, state.chrSize]);

  let x = d3
    .scaleLinear()
    .range([0, width - offset * 2])
    .domain([state.start, state.end]);

  let densityData = {};

  // Axis
  let axisChr = d3.axisBottom(xChr);
  let axis = d3.axisTop(x);

  // Karyotype
  KaryotypeBar(svg, state, xChr);

  // Chart
  let chart = svg
    .append("g")
    .attr("class", "chart")
    .attr("transform", "translate(0, 0)") // !!!
    .attr("clip-path", `url(#clipPath)`);

  // Context
  let context = svg.append("g").attr("class", "context");

  let chartAxis = chart
    .append("g")
    .attr("class", "chart-axis")
    .attr("transform", `translate(${offset}, 102)`)
    .call(axis);

  let chartFeatures;
  // chartFeatures = chart.append("g").attr("transform", `translate(0, 126)`);
  // chartFeatures.append("rect").attr("class", `genes-bg`);

  let chartSNP = chart.append("g").attr("transform", `translate(0, 104)`);
  let chartSV = chart.append("g").attr("transform", `translate(0, 510)`);

  impacts.map((impact, level) => {
    chartSNP
      .append("g")
      .attr("class", `snp-${impact}`)
      .attr("transform", `translate(0, ${level * densityHeight})`)
      .append("rect")
      .attr("class", `variants-bg`);
  });

  chartSV
    .append("rect")
    .attr("class", `variants-bg`)
    .attr("transform", `translate(0, 0)`);

  let brush = d3
    .brushX()
    .extent([
      [0, 1],
      [width + 1, 33],
    ])
    .on("brush end", brushed);

  context
    .append("g")
    .attr("class", "axis axis--x")
    .attr("transform", `translate(0, 35)`)
    .call(axisChr);

  let brushNode = context
    .append("g")
    .attr("class", "brush")
    .call(brush)
    .call(brush.move, [xChr(state.start), xChr(state.end)]);

  /* ------------------------------------------------------------------------------------------ */
  function GroupVariants(items, distance = 24) {
    let group = [];
    let groups = [];
    let last = -Infinity;

    (items || [])
      .sort((a, b) => a.pos - b.pos)
      .map((v) => {
        const pos = x(v.pos);
        v.end = v.end || v.pos + 1;
        if (last + distance < pos && group.length > 0) {
          groups.push(group);
          group = [v];
        } else {
          group.push(v);
        }
        last = Math.max(x(v.pos), last);
      });

    if (group.length > 0) groups.push(group);

    return groups.map((gr) => ({
      items: gr,
      left: gr[0].pos,
      right: Math.max(...gr.map((v) => v.end)),
    }));
  }
  function WriteDensity(data, key, container) {
    const dData = data.density.map((v, k) => ({
      value: v,
      position: data.begin + data.step * k,
    }));

    const top = Math.max(4, d3.extent(dData, (d) => d.value)[1]);

    let yTop = d3.scaleLinear().domain([0, top]).range([0, 17]);
    let yBottom = d3.scaleLinear().domain([0, top]).range([0, -17]);

    if (!densityData[key]) {
      densityData[key] = {
        top: d3
          .line()
          .x((d) => x(d.position) + offset)
          .y((d) => yTop(d.value))
          .curve(d3.curveMonotoneX),
        bottom: d3
          .line()
          .x((d) => x(d.position) + offset)
          .y((d) => yBottom(d.value))
          .curve(d3.curveMonotoneX),
      };
    } else {
      densityData[key].top.y((d) => yTop(d.value));
      densityData[key].bottom.y((d) => yBottom(d.value));
    }

    container
      .append("path")
      .datum(dData)
      .attr("class", `density top line`)
      .attr("d", densityData[key].top);
    container
      .append("path")
      .datum(dData)
      .attr("class", `density bottom line`)
      .attr("d", densityData[key].bottom);
  }

  function WriteFeatures() {
    return;
    state.levels = Levels(state.features || [], x);

    chartFeatures.selectAll(".feature-group").remove();

    let levels_engaged = { 0: [], 1: [], 2: [], 3: [] };
    let secondary = [];

    state.levels.map((f) => {
      const g = chartFeatures
        .append("g")
        .attr("class", `feature-group ${f.SO_biotype}`)
        .attr("id", `feature_${f.feature_id}`);

      g.append("rect").attr(
        "class",
        `feature ${f.SO_biotype} ${f.width < 50 ? "short" : ""}`
      );

      let title = "";
      if (f.width > WordLength(f.short)) title = f.short;
      if (f.width > WordLength(f.long)) title = f.long;
      g.append("text").text(title);

      if (title !== "") {
        const p1 = Math.max(0, x(f.start));
        levels_engaged[f.level].push({
          p1: p1,
          p2: p1 + WordLength(title) + 4,
        });
      } else {
        secondary.push(f);
      }

      if (f.SO_biotype === "gene" && f.width > 50) {
        (f.exons || []).map((ex) => {
          g.append("rect")
            .attr("class", `exon`)
            .attr("id", `exon_${ex.feature_id}`);
        });
      }
    });

    secondary.map((f) => {
      const p1 = Math.max(0, x(f.start));
      const title_range = { p1: p1, p2: p1 + WordLength(f.short) + 4 };

      if (Intersect(title_range, levels_engaged[f.level])) return;

      levels_engaged[f.level].push(title_range);
      const g = chartFeatures.select(`#feature_${f.feature_id}`);
      g.select("text").text(f.short);
    });
  }
  function AlignFeatures(animation = true) {
    return;
    (state.levels || []).map((f) => {
      const g = chartFeatures.select(`#feature_${f.feature_id}`);

      g.transition().duration(500);

      g.attr(
        "transform",
        `translate(${x(f.start) + offset}, ${f.level * geneHeight})`
      );
      g.select(".feature").attr("width", Math.abs(x(f.end) - x(f.start)));

      let title_offset = 0;
      if (x(f.start) < 0) title_offset = -x(f.start);

      g.select("text").attr("transform", `translate(${title_offset}, -2)`);
      if (!animation) g.select("text").remove();

      if (f.SO_biotype !== "gene") return;

      f.exons.map((ex) => {
        const w = Math.abs(x(ex.end) - x(ex.start));
        g.select(`#exon_${ex.feature_id}`)
          .attr("width", w >= 0.5 ? w : 0.5)
          .attr("transform", `translate(${x(ex.start) - x(f.start)}, 0)`);
      });
    });
  }

  function WriteSNPPoints(line, impact, level) {
    console.log("line.snp", line.snp);
    state.snp_groups[level] = GroupVariants(line.snp || [], 32);
    console.log("state.snp_groups[level]", state.snp_groups[level]);

    state.snp_groups[level].map((gr) => {
      const v = gr.items[0];

      const g = chartSNP
        .append("g")
        .attr("class", `snp-group snp-${impact}`)
        .attr("id", `variant_${v.id}`);

      const H = Math.min(variantHeight - 2, variantHeight * v.freq);

      g.append("rect")
        .attr("height", H)
        .attr("transform", `translate(0, ${variantHeight - H})`)
        .attr("class", `filler`);

      g.append("rect").attr("class", `box`);

      if (gr.items.length > 1) {
        g.append("text").attr("class", `count`).text(`${gr.items.length}`);
      } else {
        g.append("text")
          .attr("class", `freq`)
          .text((v.freq || 0).toFixed(4));
      }
    });
  }
  function WriteSNP() {
    chartSNP.selectAll(".density").remove();
    chartSNP.selectAll(".snp-group").remove();

    state.snp_groups = {};

    impacts.map((impact, level) => {
      const line = state[`data/snp/${impact}`];
      if (!line) return;
      const container = chartSNP.select(`.snp-${impact}`);
      if (line.density) return WriteDensity(line, impact, container);
      if (line.snp) return WriteSNPPoints(line, impact, level);
    });
  }
  function AlignSNP() {
    impacts.map((impact, level) => {
      if (densityData[impact]) {
        chartSNP
          .selectAll(`.snp-${impact} .density.top`)
          .attr("d", densityData[impact].top);
        chartSNP
          .selectAll(`.snp-${impact} .density.bottom`)
          .attr("d", densityData[impact].bottom);
      }

      if (!state.snp_groups || !state.snp_groups[level]) return;

      state.snp_groups[level].map((gr) => {
        const v = gr.items[0];
        console.log("v", v);
        const top = level * densityHeight + 4;
        const g = chartSNP.selectAll(`#variant_${v.id}`);

        const positions = gr.items.map((v) => x(v.pos));
        const add = Math.max(...positions) - Math.min(...positions);

        g.attr("transform", `translate(${x(v.pos) - 5 + offset}, ${top})`);
        g.selectAll(".box, .filler").attr("width", `${10 + add}px`);
        g.select(".freq").attr("transform", `translate(${5 + add / 2}, 27)`);
        g.select(".count").attr("transform", `translate(${5 + add / 2}, 12)`);
      });
    });
  }

  function WriteSVPoints(items) {
    state.sv_groups = GroupVariants(items);
    state.sv_groups.map((gr, i) => {
      console.log("gr", gr);

      const g = chartSV
        .append("g")
        .attr("class", `sv-group`)
        .attr("id", `sv_${i}`);

      g.append("rect").attr("class", `border`);
      if (gr.items.length === 1) {
        let type = gr.items[0].type.toLowerCase();
        type = type[0].toUpperCase() + type.substr(1);
        g.append("text").text(type);
        WriteSVContent(gr.items[0], g);
      } else {
        g.append("text").text(`x${gr.items.length}`);
        gr.items.map((v) => {
          g.append("rect")
            .attr("id", `svx_${v.id}`)
            .attr("class", `segment c-${v.start}-${v.end}`);
        });
      }
    });
  }
  function WriteSV() {
    chartSV.selectAll(".sv-group").remove();
    chartSV.selectAll(".density").remove();
    if (!state["data/sv"]) return;
    if (state["data/sv"].density)
      return WriteDensity(state["data/sv"], "svd", chartSV);
    if (state["data/sv"].sv) return WriteSVPoints(state["data/sv"].sv);
  }
  function AlignSV() {
    if (densityData["svd"]) {
      chartSV.select(`.density.top`).attr("d", densityData["svd"].top);
      chartSV.select(`.density.bottom`).attr("d", densityData["svd"].bottom);
    }

    (state.sv_groups || []).map((gr, i) => {
      const g = chartSV.selectAll(`#sv_${i}`);
      const w = x(gr.right - 1) - x(gr.left) + 16;

      g.attr("transform", `translate(${x(gr.left) - 8 + offset}, 5)`);
      g.select(".border").attr("width", w);
      g.select("text").attr("transform", `translate(${w / 2}, 24)`);

      if (gr.items.length === 1) {
        AlignSVContent(gr.items[0], g);
      } else {
        gr.items.map((v) => {
          const wx = Math.max(1, x(v.end - 1) - x(v.start));
          g.select(`#svx_${v.id}`)
            .attr("width", wx)
            .attr("transform", `translate(${x(v.start) - x(gr.left) + 8}, 0)`);
        });
      }
    });
  }

  const AlignSVContent = (v, g) => {
    const w = x(v.end || 1 - 1) - x(v.start) + 16;
    if (v.type === "DUP") {
      g.select(".line-top")
        .attr("x1", 2)
        .attr("x2", w - 2);
      g.select(".line-bottom")
        .attr("x1", 2)
        .attr("x2", w - 2);
    }
    if (v.type === "DEL") {
      g.select(".r-hor")
        .attr("x1", w - 5)
        .attr("x2", w);
      g.select(".r-del")
        .attr("x1", w - 3)
        .attr("x2", w - 7);
    }
    if (v.type === "INV") {
      g.select(".line-top")
        .attr("x1", 6)
        .attr("x2", w - 2);
      g.select(".line-bottom")
        .attr("x1", 2)
        .attr("x2", w - 6);
      g.select(".arr-rt")
        .attr("x1", w - 5)
        .attr("x2", w - 2);
      g.select(".arr-rb")
        .attr("x1", w - 2)
        .attr("x2", w - 5);
    }
  };
  const WriteSVContent = (v, g) => {
    const Liner = (lx) => {
      lx.map((line) => {
        g.append("line")
          .attr("class", `l ${line[4] || null}`)
          .attr("x1", line[0])
          .attr("x2", line[2])
          .attr("y1", line[1])
          .attr("y2", line[3]);
      });
    };
    if (v.type === "DUP") {
      Liner([
        [2, 5, 14, 5, "line-top"],
        [2, 9, 14, 9, "line-bottom"],
      ]);
    }
    if (v.type === "DEL") {
      Liner([
        [0, 7, 5, 7, "l-hor"],
        [7, 3, 3, 11, "l-del"],
        [11, 7, 16, 7, "r-hor"],
        [13, 3, 9, 11, "r-del"],
      ]);
    }
    if (v.type === "INV") {
      Liner([
        [11, 2, 14, 5, "arr-rt"],
        [14, 5, 11, 8, "arr-rb"],
        [5, 6, 2, 9, "arr-lt"],
        [2, 9, 5, 12, "arr-lb"],
        [6, 5, 14, 5, "line-top"],
        [2, 9, 10, 9, "line-bottom"],
      ]);
    }
    if (v.type === "INS") {
      Liner([
        [0, 7, 6, 7],
        [10, 7, 16, 7],
        [4, 3, 8, 11],
        [12, 3, 8, 11],
      ]);
    }
    if (v.type === "BND") {
      Liner([
        [0, 5, 10, 5],
        [6, 9, 16, 9],
        [3, 12, 13, 2],
        [3, 8, 3, 12.5],
        [3, 12, 7, 12],
        [9, 2, 13.5, 2],
        [13, 2, 13, 6],
      ]);
    }
  };

  ["DUP", "DEL", "INV", "INS", "BND", "SNV"].map((type) => {
    const e = d3.select("#sv-filter-" + type.toLowerCase());
    if (!e.node()) return;
    const svg = e
      .append("svg")
      .attr("class", `legend`)
      .attr("overflow", "visible")
      .attr("viewBox", [0, 0, 16, 14]);
    svg
      .append("rect")
      .attr("width", 16)
      .attr("height", 14)
      .attr("class", `border`);
    WriteSVContent({ type: type }, svg);
  });

  function align(animation = true) {
    AlignFeatures();
    AlignSNP(animation);
    AlignSV();
  }

  /* ------------------------------------------------------------------------------------------ */
  function brushed() {
    let px = d3.event.selection || xChr.range();
    let bp = px.map((e) => Math.round(xChr.invert(e)));

    x.domain(bp);
    chartAxis.call(axis);
    align(false);

    if (timer === null) {
      if (d3.event.type === "brush") return; // Only mouseUp events
      parent.onPositionUpdate(bp);
    }
  }

  /* ------------------------------------------------------------------------------------------ */
  return {
    setPosition: (newState) => {
      console.log("React -> D3::setPosition", newState);

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
      }, 550);

      state = newState;
      align(true);

      brushNode
        .transition()
        .duration(500)
        .call(brush.move, [xChr(newState.start), xChr(newState.end)]);

      chartAxis.call(axis);
    },

    loadData: (newState) => {
      console.log("React -> D3::loadData", newState);
      state = newState;

      WriteFeatures();
      WriteSV();
      WriteSNP();

      align();
    },
  };
}

export default GenomeBrowser;
